<template>
  <div>
    <l-button variant="light" class="gap-2 relative" @click="openModal">
      <icon name="settings" set="regular" class="text-gray-400"/>
      Settings
      <icon v-if="progress < 100" name="circleWarning" class="rounded-full bg-white dark:bg-gray-900 text-yellow absolute z-10 -top-2 -right-2"/>
    </l-button>

    <modal
      title="Budget settings"
      :show="showModal"
      scrollable
      size="3xl"
      @close="closeModal"
    >
      <modal-tabs v-bind="{ items }" class="h-full sm:min-h-[550px]">
        <template #default="{ item }">
          <h3 class="sr-only">
            {{ item.title }}
          </h3>
          <component :is="item.component" v-if="item" v-model="user"/>
        </template>
      </modal-tabs>
    </modal>
  </div>
</template>

<script setup>
import ContributionForm from "@/components/forms/ContributionForm.vue"
import DebtPaymentSettingsForm from "@/components/forms/DebtPaymentSettingsForm.vue"
import DiscountEligibilitySettingsForm from "@/components/forms/DiscountEligibilitySettingsForm.vue"
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import LsatGpaSettingsForm from "@/components/forms/LsatGpaSettingsForm.vue"
import Modal from "@/components/modals/Modal.vue"
import ModalTabs from "@/components/ModalTabs.vue"
import RaceSettingsForm from "@/components/forms/RaceSettingsForm.vue"
import { computed, ref } from "vue"
import { currency } from "@/support"
import { useAuth } from "@/composables/useAuth"
import { useRaces } from "@/composables/useRaces"

defineProps({
  progress: Number,
})

const { user } = useAuth()

const { races } = useRaces()

const showModal = ref(false)

const closeModal = () => {
  showModal.value = false
}

const openModal = () => {
  showModal.value = true
}

const items = computed(() => [
  {
    title: "Your contribution",
    icon: "fa-piggy-bank",
    component: ContributionForm,
    subtitle: currency(user.value.finances.y1_contribution + user.value.finances.y2_contribution + user.value.finances.y3_contribution + user.value.finances.y4_contribution + user.value.finances.y5_contribution) || "Not set",
  },
  {
    title: "LSAT and GPA",
    icon: "fa-ranking-star",
    component: LsatGpaSettingsForm,
    subtitle: `${user.value.lsat || "Not set"} / ${user.value.gpa || "Not set"}`,
  },
  {
    title: "Race/ethnicity",
    icon: "fa-rectangle-history-circle-user",
    component: RaceSettingsForm,
    subtitle: races?.filter((race) => user.value.race.includes(race.value)).map(race => race.name).join(", "),
  },
  {
    title: "Debt payment",
    icon: "fa-hand-holding-circle-dollar",
    component: DebtPaymentSettingsForm,
    subtitle: `${user.value.finances.target_tax || 10}% for ${user.value.finances.target_debt_period} years`,
  },
  {
    title: "Discount eligibility",
    icon: "fa-chart-pie-simple-circle-dollar",
    component: DiscountEligibilitySettingsForm,
    subtitle: user.value.states?.map((state) => state.code).join(", "),
  },
])
</script>
